import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { magicLoginWithToken } from "../../lib/api";
import form from "../../components/LoginForm.module.css";

/**
 * Public landing page for an emailed sign-in (magic) link: the token in the
 * query string redeems straight into a session cookie, then the browser moves
 * on to the normal landing redirect. No password is ever entered.
 */
export function MagicLoginPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const [error, setError] = useState<string | null>(null);
  const redeemed = useRef(false);

  useEffect(() => {
    if (!token || redeemed.current) return;
    redeemed.current = true;
    magicLoginWithToken(token)
      .then(() => {
        // Full navigation so the auth context re-reads /auth/me with the new
        // cookie and every cached surface starts from the signed-in account.
        window.location.assign("/");
      })
      .catch((redeemError: unknown) => {
        setError(
          redeemError instanceof Error ? redeemError.message : "This link is invalid or has expired",
        );
      });
  }, [token]);

  return (
    <div className="auth-page">
      <div className={form.root}>
        <h1 className={form.title}>Signing you in…</h1>
        {error ? (
          <>
            <p className={form.error} role="alert">
              {error}
            </p>
            <Link className={form.submit} to="/login">
              Go to sign in
            </Link>
          </>
        ) : (
          <p className={form.hint}>One moment — you are being signed in.</p>
        )}
      </div>
    </div>
  );
}
